import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { Button, Camera01 } from "@opendate-app/setlist";
import ImageCropModal from "../../../shared/ImageCropModal";
import { fileToDataUrl } from "../../../shared/cropUtils";
import { toastError } from "../../../shared/toastHelper";

function InstructorPhotoField({ imageUrl, name, onUpload, onRemove }) {
  const inputRef = useRef(null);
  const [crop, setCrop] = useState(null);

  const pick = () => inputRef.current?.click();

  const onFileChosen = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    try {
      setCrop({ src: await fileToDataUrl(file), fileName: file.name });
    } catch (e) {
      toastError("Could not read that image. Try another file.");
    }
  };

  return (
    <div className="instructor-photo">
      <button
        type="button"
        className={`instructor-photo__circle${imageUrl ? " instructor-photo__circle--filled" : ""}`}
        onClick={pick}
        aria-label={imageUrl ? "Change photo" : "Upload photo"}
      >
        {imageUrl ? <img src={imageUrl} alt={name ? `${name}'s photo` : "Instructor photo"} /> : <Camera01 width={24} height={24} aria-hidden="true" />}
      </button>
      <div className="instructor-photo__actions">
        <div className="instructor-photo__buttons">
          <Button variant="secondary" size="sm" onClick={pick}>{imageUrl ? "Change Photo" : "Upload Photo"}</Button>
          {imageUrl && <Button variant="link-gray" size="sm" onClick={onRemove}>Remove</Button>}
        </div>
        <div className="instructor-photo__hint">PNG, JPG, WebP or GIF, recommended 400 × 400 px or larger.</div>
      </div>
      <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" className="d-none" onChange={onFileChosen} data-testid="instructor-photo-input" />
      <ImageCropModal
        open={!!crop}
        onClose={() => setCrop(null)}
        onCropComplete={(file) => {
          setCrop(null);
          onUpload(file);
        }}
        imageSrc={crop?.src}
        aspectRatio={1}
        fileName={crop?.fileName || "instructor-photo.jpg"}
      />
    </div>
  );
}

InstructorPhotoField.propTypes = {
  imageUrl: PropTypes.string,
  name: PropTypes.string,
  onUpload: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default InstructorPhotoField;
